import SettingTimesheetCreateWork from "../components/SettingTimesheetCreateWork";

const SettingTimesheetCreateWorkPage = () => {
    return (
        <SettingTimesheetCreateWork />
    )
}

export default SettingTimesheetCreateWorkPage;